import { EnvironmentVariables } from '../types/environment-variables';

const environment: EnvironmentVariables = {
  viteAlgoliaAppId: '9D5RSWEEXY',
  viteAlgoliaSearchKey: 'fe820f92e54d2ae638964bad633082d4',
  viteAlgoliaIndexName: 'production_EEBusiness_pages',
  viteNextPublicEeHeaderUrl:
    'https://business.ee.co.uk/content/ee/business/en/jcr:content/header-iparsys/responsivegrid.model.json',
  viteNextPublicEeFooterUrl:
    'https://business.ee.co.uk/content/experience-fragments/eeb-site/en/site/footer/master/jcr:content/root.model.json',
  viteAdobeLaunchEnvironment:
    'https://assets.adobedtm.com/9a4a45c521ce/e275af1d9edd/launch-dd16a66a9a58.min.js',
  viteGuestCartEndpoint: 'https://business.ee.co.uk/ee-shop/api/cart/guest',
  environment: 'prod',
};

export default environment;
